import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "services" }
const _hoisted_2 = { class: "features" }
const _hoisted_3 = { class: "feature-wrapper" }
const _hoisted_4 = { class: "feature-grid" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "popup-box" }
const _hoisted_7 = { class: "popup-list" }
const _hoisted_8 = { class: "care-costs" }
const _hoisted_9 = { class: "costs-card" }
const _hoisted_10 = { class: "feature-grid" }
const _hoisted_11 = { class: "feature-card" }
const _hoisted_12 = { class: "feature-icon" }
const _hoisted_13 = { class: "feature-card" }
const _hoisted_14 = { class: "feature-icon" }
const _hoisted_15 = { class: "feature-card" }
const _hoisted_16 = { class: "feature-icon" }
const _hoisted_17 = { class: "feature-card" }
const _hoisted_18 = { class: "feature-icon" }

import {ref} from "vue";
import {Car, ClipboardPlus, Dices, Flower2, Landmark, Layers, PhoneCall, Pill, ShoppingBag} from "lucide-vue-next";

import '@/assets/styles/service.css';

interface Service {
  name: string;
  details: string;
  icon: any; // Icon Component
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceView',
  setup(__props) {

const selected = ref<Service | null>(null);

const services: Service[] = [
  {
    name: "Häusliche Krankenpflege",
    details:
        "Leistungen nach § 37.1 SGB V (Krankenhausvermeidungspflege) sowie § 37.2 SGB V (Behandlungspflege), Medikamentengabe, Wundversorgung, Injektionen (z. B. Insulin), Blutdruck- und Blutzuckerkontrolle, Kompressionsverbände, Versorgung nach Krankenhausaufenthalt, Krankenhausvermeidungspfelege",
    icon: Pill,
  },
  {
    name: "Grundpflege",
    details:
        "Leistungen nach § 36 SGB XI, Unterstützung bei der Körperpflege, Hilfe beim An- und Auskleiden, Mobilisation, Hilfe bei der Nahrungsaufnahme, Unterstützung bei der Toilettengang, Positionswechsel",
    icon: Layers,
  },
  {
    name: "Betreuung & Alltagsbegleitung",
    details:
        "Leistungen nach § 45b SGB XI, Stundenweise Betreuung, Aktivierende Gespräche, Begleitung zu Arztterminen, Spaziergänge, Unterstützung im Alltag",
    icon: Dices,
  },
  {
    name: "Hauswirtschaftliche Versorgung",
    details:
        "Reinigung der Wohnung, Wäschepflege, Einkaufen, Zubereitung von Mahlzeiten, Unterstützung im Haushalt",
    icon: ShoppingBag,
  },
  {
    name: "Beratung & Pflegegrad",
    details:
        "Pflegeberatung nach §37 SGB XI, Unterstützung bei Anträgen, Hilfe bei Einstufung in Pflegegrade, Beratung für Angehörige",
    icon: ClipboardPlus,
  },
  {
    name: "Verhinderungspflege",
    details:
        "Leistungen nach § 39 SGB XI, Vertretung pflegender Angehöriger, Kurzzeitige Entlastung im Alltag, Flexible Einsatzzeiten",
    icon: Car,
  },
  {
    name: "Individuelle Zusatzleistungen",
    details:
        "24-Stunden Rufbereitschaft, Individuelle Pflegekonzepte, 24-Stunden-Betreuung",
    icon: PhoneCall,
  },
  {
    name: "Gartenpflege",
    details:
        "Rasenpflege, Beetgestaltung, Heckenschnitt, Laubbeseitigung, Winterdienst",
    icon: Flower2,
  },
];
const showPopup = (service: Service) => {
  selected.value = service;
};

const closePopup = () => {
  selected.value = null;
};

// Hilfsfunktion für Liste im Template
const detailsList = (details: string) =>
    details.split(",").map(d => d.trim()).filter(d => d.length > 0);


return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("h1", null, "Dienstleistungen", -1)),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(services, (service) => {
              return _createElementVNode("div", {
                class: "feature-card",
                key: service.name,
                onClick: ($event: any) => (showPopup(service))
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(service.icon), { class: "feature-icon" })),
                _createElementVNode("h3", null, _toDisplayString(service.name), 1)
              ], 8, _hoisted_5)
            }), 64))
          ]),
          (selected.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "popup-overlay",
                onClick: _withModifiers(closePopup, ["self"])
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("button", {
                    class: "close-btn-service",
                    onClick: closePopup
                  }, "×"),
                  (_openBlock(), _createBlock(_resolveDynamicComponent(selected.value.icon), { class: "popup-icon" })),
                  _createElementVNode("h2", null, _toDisplayString(selected.value.name), 1),
                  _createElementVNode("ul", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailsList(selected.value.details), (detail) => {
                      return (_openBlock(), _createElementBlock("li", { key: detail }, _toDisplayString(detail), 1))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("section", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _cache[12] || (_cache[12] = _createElementVNode("h1", null, "Kosten & Beratung", -1)),
          _cache[13] || (_cache[13] = _createElementVNode("p", null, " Viele unserer Leistungen werden von der Pflegekasse oder der Krankenkasse übernommen. Welche Unterstützung möglich ist, hängt vom Pflegegrad und der individuellen Situation ab. ", -1)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_unref(ClipboardPlus))
              ]),
              _cache[1] || (_cache[1] = _createElementVNode("h3", null, "Pflegeversicherung", -1)),
              _cache[2] || (_cache[2] = _createElementVNode("p", null, "Leistungen nach Pflegegrad 1–5", -1)),
              _cache[3] || (_cache[3] = _createElementVNode("p", null, "Verhinderungspflege", -1)),
              _cache[4] || (_cache[4] = _createElementVNode("p", null, "Entlastungsbetrag", -1))
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_unref(Pill))
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("h3", null, "Häusliche Krankenpflege", -1)),
              _cache[6] || (_cache[6] = _createElementVNode("p", null, "Über ärztliche Verordnung (§ 37 SGB V)", -1))
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_unref(Landmark))
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("h3", null, "Weitere Kostenträger", -1)),
              _cache[8] || (_cache[8] = _createElementVNode("p", null, "Sozialhilfeträger", -1)),
              _cache[9] || (_cache[9] = _createElementVNode("p", null, "Landeswohlfahrtsverband (LWV)", -1))
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_unref(Layers))
              ]),
              _cache[10] || (_cache[10] = _createElementVNode("h3", null, "Individuelle Zusatzleistungen", -1)),
              _cache[11] || (_cache[11] = _createElementVNode("p", null, "Nach persönlichem Bedarf", -1))
            ])
          ]),
          _cache[14] || (_cache[14] = _createElementVNode("p", { class: "cost-hint" }, " Gerne beraten wir Sie persönlich und unterstützen Sie bei Anträgen sowie bei der Einstufung in einen Pflegegrad. ", -1)),
          _cache[15] || (_cache[15] = _createElementVNode("a", {
            href: "/contact",
            class: "consult-button"
          }, " Kostenlose Beratung anfragen ", -1))
        ])
      ])
    ])
  ], 64))
}
}

})